import React from 'react'

const DBCWealthMethodOrderBump = () => {
  return (
    <div>DBCWealthMethodOrderBump</div>
  )
}

export default DBCWealthMethodOrderBump